import type { DemoKey } from './keys';

export const es: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometría · 3D',
  'panel.figure': 'Figura',
  'panel.dims': 'Dimensiones',
  'panel.style': 'Aspecto',
  'panel.lines': 'Líneas especiales',
  'style.body': 'Cuerpo',
  'style.line': 'Línea',
  'style.cut': 'Sección',
  'style.labels': 'Etiquetas de vértices',
  'group.face': 'Diagonales de caras / generatrices',
  'group.space': 'Diagonales / ejes / medianas',
  'split.label': 'Sección',
  'btn.animate': 'Animar',
  'btn.reset': 'Reiniciar',
  'hint.line1': 'Arrastra para girar · Desplaza para hacer zoom',
  'hint.line2': 'Haz clic en una línea para seleccionarla',
  'fig.cuboid': 'Paralelepípedo',
  'fig.cube': 'Cubo',
  'fig.triPrism': 'Prisma triangular',
  'fig.hexPrism': 'Prisma hexagonal',
  'fig.tetrahedron': 'Tetraedro',
  'fig.squarePyramid': 'Pirámide cuadrada',
  'fig.cylinder': 'Cilindro',
  'fig.cone': 'Cono',
  'fig.sphere': 'Esfera',
  'fig.frustumPyramid': 'Tronco de pirámide',
  'fig.frustumCone': 'Tronco de cono',
  'dim.length': 'longitud',
  'dim.width': 'ancho',
  'dim.height': 'altura',
  'dim.side': 'lado',
  'dim.radius': 'radio',
  'dim.r1': 'radio inferior',
  'dim.r2': 'radio superior',
  'dim.sideBase': 'lado base',
  'dim.sideTop': 'lado superior',
  'info.face': 'cara',
  'info.center': 'por el centro',
  'info.diagonal': 'diagonal',
  'info.axial': 'diagonal axial',
  'info.diameter': 'diámetro',
  'info.generator': 'generatriz',
  'info.axis': 'eje',
  'info.height': 'altura',
  'info.median': 'mediana',
  'info.apothem': 'apotema',
  'info.diameterBase': 'diámetro base',
  'info.diameterTop': 'diámetro superior',
};
